import { render, staticRenderFns } from "./slider-index-slide-new.vue?vue&type=template&id=3c0b64f6&scoped=true"
import script from "./slider-index-slide-new.vue?vue&type=script&lang=js"
export * from "./slider-index-slide-new.vue?vue&type=script&lang=js"
import style0 from "./slider-index-slide-new.vue?vue&type=style&index=0&id=3c0b64f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b64f6",
  null
  
)

export default component.exports